import { Suspense, useContext, type PropsWithChildren } from "react";

import { lazyWithRetry } from "@/lib/lazyWithRetry";
import { AuthContext } from "@/shared/context/auth-context";
import { HeaderNotificationContext } from "@/shared/context/header-notification-context";

const NotificationBell = lazyWithRetry(() => import("./NotificationBell"));

export function NotificationHeaderProvider({ children }: PropsWithChildren) {
  const { session } = useContext(AuthContext);
  return (
    <HeaderNotificationContext.Provider
      value={
        session?.user.id ? (
          <Suspense fallback={null}>
            <NotificationBell key={session.user.id} />
          </Suspense>
        ) : null
      }
    >
      {children}
    </HeaderNotificationContext.Provider>
  );
}
